import { HDate } from '@hebcal/core';

/**
 * Compute selichot applicability.
 *
 * Sephardic/Mizrahi: 1 Elul through Yom Kippur (10 Tishrei)
 * Ashkenazi: Motzaei Shabbat before RH (or 1 week earlier if RH on Mon/Tue) through YK
 *
 * @param {HDate} hdate
 * @param {string} edah - 'ashkenaz' | 'sephardic' | 'mizrahi'
 * @returns {{ applicable: boolean, reason: string|null }}
 */
export function computeSelichot(hdate, edah) {
  const m = hdate.getMonth();
  const d = hdate.getDate();
  const year = hdate.getFullYear();

  // Aseret Yemei Teshuvah: 1-10 Tishrei — all edot say selichot
  if (m === 7 && d >= 1 && d <= 10) {
    return { applicable: true, reason: 'עשי״ת' };
  }

  if (edah === 'sephardic' || edah === 'mizrahi') {
    // All of Elul
    if (m === 6) {
      return { applicable: true, reason: 'אלול' };
    }
  }

  if (edah === 'ashkenaz') {
    // Motzaei Shabbat before RH, or 1 week earlier if RH falls on Mon/Tue
    if (m === 6) {
      const rh = new HDate(1, 7, year);
      const rhDay = rh.getDay(); // 0=Sun

      // Find the Motzaei Shabbat before RH
      // RH on Mon (1) or Tue (2) → start 2 Shabbatot before
      // Otherwise → start 1 Shabbat before
      const shabbatBefore = rh.onOrBefore(6); // Saturday before RH
      let startDate;
      if (rhDay === 1 || rhDay === 2) {
        // Need at least 4 days of selichot → go back 1 more week
        startDate = new HDate(shabbatBefore.abs() - 7);
      } else {
        startDate = shabbatBefore;
      }

      // Selichot start motzaei Shabbat = Sunday after that Shabbat
      const selichotStart = new HDate(startDate.abs() + 1);

      if (hdate.abs() >= selichotStart.abs()) {
        return { applicable: true, reason: 'אלול' };
      }
    }
  }

  return { applicable: false, reason: null };
}
